<template>
  <div>
    <div class="row d-flex justify-content-between align-items-start">
      <vs-list-item
        class="col-10 ml-2"
        :title="getSelectedElement.owner"
        subtitle="Propietario"
        data-cy="file-owner"
      >
      </vs-list-item>
      <b-button
        data-cy="edit-owner"
        class="col-1 p-0 m-0"
        v-tooltip="userPermissions.totalControl === 0
          ? 'No puede editar porque no es propietario'
          : 'Editar propietario'"
        variant="ligth"
        @click="showModal = true"
        :disabled="userPermissions.totalControl === 0"
        :class="{ 'cursor-not-allowed': userPermissions.totalControl === 0 }"
      >
        <font-awesome-icon class="mt-4" icon="edit"/>
      </b-button>
    </div>
    <b-modal
      :no-close-on-backdrop="true"
      title="Cambiar propietario"
      hide-footer
      v-model="showModal"
      centered
    >
      <ChangeOwnerModal @close="showModal = false"/>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ChangeOwnerModal from '@/febos/global/documentManagement/vistas/modals/ChangeOwnerModal';

export default {
  name: 'ChangeOwnerView',
  components: {
    ChangeOwnerModal,
  },
  data() {
    return {
      showModal: false,
      userPermissions: {
        read: 0,
        write: 0,
        totalControl: 0
      },
    };
  },
  created() {
    this.loadPermissions();
  },
  watch: {
    getSelectedElement() {
      this.loadPermissions();
    }
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedElement',
      'getPermissionsStack'
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
    ]),
  },
  methods: {
    loadPermissions() {
      const selected = this.getSelectedElement;
      this.userPermissions.read = selected.loggedUserPermissions.lectura;
      this.userPermissions.write = selected.loggedUserPermissions.escritura;
      this.userPermissions.totalControl = selected.loggedUserPermissions.controlTotal;
    }
  }
};
</script>
